import { useMutation } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router';
import { FullScreenLoader } from '@/components/FullScreenLoader';
import { Button } from '@/components/ui/button';
import { api, errorMessage } from '@/lib/api';
import { useAuth } from '@/lib/auth';

/** `/demo`: pide una sesión demo y entra directo al local de prueba. */
export function DemoPage() {
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const started = useRef(false);

  const session = useMutation({
    mutationFn: () => api.demo.session(),
    onSuccess: (res) => {
      setSession(res);
      navigate(`/l/${res.localId}/resumen`, { replace: true });
    },
  });

  useEffect(() => {
    if (started.current) return; // StrictMode monta dos veces en dev
    started.current = true;
    session.mutate();
  }, [session]);

  if (session.isError) {
    return (
      <div className="flex min-h-dvh flex-col items-center justify-center gap-4 p-6 text-center">
        <h1 className="text-lg font-semibold">No pudimos abrir la demo</h1>
        <p className="text-sm text-muted-foreground">{errorMessage(session.error)}</p>
        <div className="flex gap-2">
          <Button onClick={() => session.mutate()}>Reintentar</Button>
          <Button variant="outline" asChild>
            <Link to="/login">Ir al login</Link>
          </Button>
        </div>
      </div>
    );
  }

  return <FullScreenLoader label="Preparando la demo…" />;
}
